import { inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import {
  AuthUser,
  confirmResetPassword,
  ConfirmResetPasswordInput,
  confirmSignUp,
  ConfirmSignUpInput,
  ConfirmSignUpOutput,
  fetchAuthSession,
  getCurrentUser,
  resetPassword,
  ResetPasswordInput,
  ResetPasswordOutput,
  signIn,
  SignInInput,
  SignInOutput,
  signOut,
  signUp,
  SignUpInput,
  SignUpOutput,
} from '@aws-amplify/auth';
import { IAuthServiceGetKeysResponse } from '../interfaces/authService/IAuthServiceGetKeysResponse';
import { IAuthServiceCreateKeyResponse } from '../interfaces/authService/IAuthServiceCreateKeyResponse';
import { IAuthServiceRevokeKeyResponse } from '../interfaces/authService/IAuthServiceRevokeKeyResponse';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http: HttpClient = inject(HttpClient);
  
  constructor() {}

  currentAuthenticatedUser(): Observable<AuthUser> {
    return from(getCurrentUser());
  }
  async isUserLoggedIn(): Promise<boolean> {
    try {
      const { userId } = await getCurrentUser();
      return true;
    } catch (err) {
      return false;
    }
  }

  login(credentials: SignInInput): Observable<SignInOutput> {
    return from(signIn(credentials));
  }

  register(user: SignUpInput): Observable<SignUpOutput> {
    return from(signUp(user));
  }
  verifyCode(option: ConfirmSignUpInput): Observable<ConfirmSignUpOutput> {
    return from(confirmSignUp(option));
  }

  currentSession(): Observable<any> {
    return from(this.getValidAuthSession());
  }

  private async getValidAuthSession() {
    const session = await fetchAuthSession();
    const expiresAt = session.tokens?.accessToken?.payload?.exp;
    const isExpiringSoon = expiresAt !== undefined && expiresAt * 1000 - Date.now() < 60000;

    if (isExpiringSoon) {
      return fetchAuthSession({ forceRefresh: true });
    }
    return session;
  }
  logout(): Observable<void> {
    return from(signOut({global: true}));
  }
  resetPassword(user: ResetPasswordInput): Observable<ResetPasswordOutput> {
    return from(resetPassword(user));
  }
  changePassword(
    username: string,
    confirmationCode: string,
    newPassword: string
  ): Observable<any> {
    const inputNewPass: ConfirmResetPasswordInput = {
      username: username,
      confirmationCode: confirmationCode,
      newPassword: newPassword,
    };
    return from(confirmResetPassword(inputNewPass));
  }

  // auth service functions

  getRefreshKeys(): Observable<Array<IAuthServiceGetKeysResponse>> {
    return this.http.get<Array<IAuthServiceGetKeysResponse>>(
      `${environment.services.urlEDI}/auth_service/keys`
    );
  }

  createRefreshKey(): Observable<IAuthServiceCreateKeyResponse> {
    return this.http.post<IAuthServiceCreateKeyResponse>(
      `${environment.services.urlEDI}/auth_service/keys`,
      {}
    );
  }

  revokeRefreshKey(uuid: string): Observable<IAuthServiceRevokeKeyResponse> {
    return this.http.delete<IAuthServiceRevokeKeyResponse>(
      `${environment.services.urlEDI}/auth_service/keys`,
      { body: { uuid } }
    );
  }

}
